// extracted by mini-css-extract-plugin
export default {"NavigationItem":"NavigationItem_NavigationItem__HU3e7","active":"NavigationItem_active__WBkSC"};